import { UpdateBehaviorTreatmentModificationProperties } from '../../../redux/API/ClientAPIHelpers/soapNoteProperties';

export enum ACTIONS {
	setState = 'setState',
	setDate = 'setDate',
	setEndTime = 'setEndTime',
	setStartTime = 'setStartTime',
	setLocationId = 'setLocationId',
	setClientTelehealthLocationId = 'setClientTelehealthLocationId',
	setUserTelehealthLocationId = 'setUserTelehealthLocationId',
	setSessionSummary = 'setSessionSummary',
	setSessionId = 'setSessionId',
	setSignature = 'setSignature',
	setSubmit = 'setSubmit',
	setIntervention = 'setIntervention',
	setReinforcement = 'setReinforcement',
	setResponseToIntervation = 'setResponseToIntervation',
	setBarriers = 'setBarriers',
	setGoalsAddressed = 'setGoalsAddressed',
	setDataAnalyzed = 'setDataAnalyzed',
	setTreatmentPlanUpdates = 'setTreatmentPlanUpdates',
	setMaladaptiveBehaviorsObserved = 'setMaladaptiveBehaviorsObserved',
	setParticipants = 'setParticipants',
	setBarrierToTreatmentOther = 'setBarrierToTreatmentOther',
	setBehaviorTreatmentModificationParticipantOther = 'setBehaviorTreatmentModificationParticipantOther',
}

export interface ActionProperties {
	payload: any;

	type: keyof typeof ACTIONS;
}

export const initialBehaviorTreatmentModificationState: UpdateBehaviorTreatmentModificationProperties = {
	barrierToTreatmentResponses: [],
	behaviorTreatmentModificationInterventionResponses: [],
	dataAnalyzed: '',
	date: '',
	startTime: '',
	endTime: '',
	goalsAddressed: '',
	locationId: '',
	maladaptiveBehaviorsObserved: '',
	reinforcementResponses: [],
	responseToIntervention: null,
	sessionId: '',
	sessionSummary: '',
	signature: '',
	submit: false,
	treatmentPlanUpdates: '',
	forcedOperation: false,
	clientTelehealthLocationId: '',
	userTelehealthLocationId: '',
	behaviorTreatmentModificationResponses: [],
	participantResponses: [],
	clientId: '',
	reportId: '',
	barrierToTreatmentOther: '',
	behaviorTreatmentModificationParticipantOther: '',
};

export const behaviorTreatmentModificationReducer = (
	state: UpdateBehaviorTreatmentModificationProperties,
	action: ActionProperties,
): UpdateBehaviorTreatmentModificationProperties => {
	const { type, payload } = action;

	switch (type) {
		case ACTIONS.setState:
			return {
				...state,
				...payload,
			};
		case ACTIONS.setLocationId:
			return {
				...state,
				locationId: payload,
			};
		case ACTIONS.setIntervention:
			return {
				...state,
				behaviorTreatmentModificationInterventionResponses: payload,
			};
		case ACTIONS.setReinforcement:
			return {
				...state,
				reinforcementResponses: payload,
			};
		case ACTIONS.setResponseToIntervation:
			return {
				...state,
				responseToIntervention: payload,
			};
		case ACTIONS.setBarriers:
			return {
				...state,
				barrierToTreatmentResponses: payload,
			};
		case ACTIONS.setGoalsAddressed:
			return {
				...state,
				goalsAddressed: payload,
			};
		case ACTIONS.setDataAnalyzed:
			return {
				...state,
				dataAnalyzed: payload,
			};
		case ACTIONS.setTreatmentPlanUpdates:
			return {
				...state,
				treatmentPlanUpdates: payload,
			};
		case ACTIONS.setMaladaptiveBehaviorsObserved:
			return {
				...state,
				maladaptiveBehaviorsObserved: payload,
			};
		case ACTIONS.setSessionSummary:
			return {
				...state,
				sessionSummary: payload,
			};
		case ACTIONS.setSignature:
			return {
				...state,
				signature: payload,
			};
		case ACTIONS.setClientTelehealthLocationId:
			return {
				...state,
				clientTelehealthLocationId: payload,
			};
		case ACTIONS.setUserTelehealthLocationId:
			return {
				...state,
				userTelehealthLocationId: payload,
			};
		case ACTIONS.setParticipants:
			return {
				...state,
				participantResponses: payload,
			};
		case ACTIONS.setBarrierToTreatmentOther:
			return {
				...state,
				barrierToTreatmentOther: payload,
			};
		case ACTIONS.setBehaviorTreatmentModificationParticipantOther:
			return {
				...state,
				behaviorTreatmentModificationParticipantOther: payload,
			};
		default:
			return state;
	}
};

export enum ERRORS {
	LocationId = 'LocationId',
	BehaviorTreatmentModificationInterventionResponses = 'BehaviorTreatmentModificationInterventionResponses',
	ResponseToIntervention = 'ResponseToIntervention',
	ReinforcementResponses = 'ReinforcementResponses',
	BarrierToTreatmentResponses = 'BarrierToTreatmentResponses',
	GoalsAddressed = 'GoalsAddressed',
	DataAnalyzed = 'DataAnalyzed',
	TreatmentPlanUpdates = 'TreatmentPlanUpdates',
	MaladaptiveBehaviorsObserved = 'MaladaptiveBehaviorsObserved',
	SessionSummary = 'SessionSummary',
	Signature = 'Signature',
	ParticipantResponses = 'ParticipantResponses',
	BarrierToTreatmentOther = 'BarrierToTreatmentOther',
	ParticipantOther = 'ParticipantOther',
}

interface BehaviorTreatmentModificationErrorStateProperties {
	BarrierToTreatmentOther: boolean;
	BarrierToTreatmentResponses: boolean;
	BehaviorTreatmentModificationInterventionResponses: boolean;
	BehaviorTreatmentModificationParticipantOther: boolean;
	DataAnalyzed: boolean;
	GoalsAddressed: boolean;
	LocationId: boolean;
	MaladaptiveBehaviorsObserved: boolean;
	ParticipantResponses: boolean;
	ReinforcementResponses: boolean;
	ResponseToIntervention: boolean;
	SessionSummary: boolean;
	Signature: boolean;
	TreatmentPlanUpdates: boolean;
}

interface ErrorActionProperties {
	payload: any;

	type: keyof typeof ERRORS;
}

export const initialBehaviorTreatmentModificationErrorState: BehaviorTreatmentModificationErrorStateProperties = {
	LocationId: false,
	BehaviorTreatmentModificationInterventionResponses: false,
	ResponseToIntervention: false,
	ReinforcementResponses: false,
	BarrierToTreatmentResponses: false,
	GoalsAddressed: false,
	DataAnalyzed: false,
	TreatmentPlanUpdates: false,
	MaladaptiveBehaviorsObserved: false,
	SessionSummary: false,
	Signature: false,
	ParticipantResponses: false,
	BarrierToTreatmentOther: false,
	BehaviorTreatmentModificationParticipantOther: false,
};

export const behaviorTreatmentModificationErrorReducer = (
	state: BehaviorTreatmentModificationErrorStateProperties,
	action: ErrorActionProperties,
) => {
	const { payload, type } = action;

	switch (type) {
		case ERRORS[type]:
			return {
				...state,
				[type]: payload,
			};
		default:
			return state;
	}
};
